const NODE_ENV = process.env.NODE_ENV || 'development';

const CONFIG = {
  development: {
    baseUrl: "http://localhost:1337",
    appUrl: "https://app.g-global.com"
  },
  staging: {
    baseUrl: "https://qa-api.g-global.cloud/tms/v1",
    appUrl: "https://app.g-global.com"
  },
  production: {
    baseUrl: process.env.REACT_APP_SOCKET_URL || "https://socket.g-global.com",
    appUrl: process.env.REACT_APP_GG_APP_URL || "https://app.g-global.com"
  }
};


export default CONFIG[NODE_ENV];



// WEBPACK FOOTER //
// ./src/config/custom.js